import { RegisterPage } from "@/interface/pages/register-page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/users/registration")({
  component: RouteComponent,
});

function RouteComponent() {
  return <RegisterPage />;
}
